import React from 'react';
import TemplatesContent from './components/templates-content';

const TemplatesView = props => (
  <TemplatesContent {...props} />
);

export default TemplatesView;
